import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useListRecordsQuery } from '@platform/state/api';
import { Picker } from '@platform/ui';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import { recordCode } from '../form/header/recordCode';
import type { IAddExistingChildProps } from './IAddExistingChildProps';

/**
 * «+ Додати наявне завдання» (прототип v4): пунктирна кнопка з пошуком записів того самого типу за кодом або назвою; не пропонує сам
 * запис, його батьківський і вже дочірні. Вибір робить запис дочірнім (поле-батько).
 */
export function AddExistingChild({ ws, rt, parent, children, onPick }: IAddExistingChildProps) {
  const { t } = useTranslation();
  const strings = useModuleStrings();
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const { data, isFetching } = useListRecordsQuery({ ws, rt: rt.key, params: { q: query || undefined, pageSize: 25, sort: 'code' } }, { skip: !open });
  const taken = new Set([parent.id, String(parent.values['parent'] ?? ''), ...children.map((c) => c.id)]);
  const items = (data?.items ?? []).filter((r) => !taken.has(r.id));
  const label = rt.key === 'task' ? t('recordPage.children.addExisting') : t('recordPage.children.addExistingOf');
  return (
    <Picker className="rtab-addexisting" value="" label={label} placeholder={label} searchable query={query} onQueryChange={setQuery} loading={isFetching}
      onOpenChange={setOpen} options={items.map((r) => ({ value: r.id, label: `${recordCode(r.display, r.code)} · ${r.title}`, sub: strings.status(rt.key, r.status, r.status) }))}
      onChange={(id) => { const r = items.find((x) => x.id === id); if (r) onPick(r); }} />
  );
}
